module.exports = __webpack_public_path__ + "static/media/novelfy.dbdcc659.png";